<template>
    <a href="#" :class="{ 'disabled' : !isEnabled }" @click="openModal('field-inspection-review')">

        <div class="item review" data-toggle="tooltip" data-placement="top" :title="getTitle">
            <i class="fa fa-eye"></i>
            <div class="status" :class="{ 'completed' : isCompleted }">
                <div>
                    <i class="fa fa-check" v-if="isCompleted"></i>
                    <i class="fa fa-times" v-else></i>
                </div>
            </div>
        </div>
        <h6 class="text-sm text-uppercase text-muted py-2 text-center w-100">Review</h6>
    </a>
</template>
<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true,
            }
        },

        data(){
            return {
                field_inspection: this.value
            }
        },

        watch:{
            value(val){
                this.field_inspection = val;
            }
        },

        computed: {

            isCompleted(){
                return this.field_inspection.is_on_review;
            },

            isEnabled(){
                if (this.authorize('admin')) return true;
                return this.value.is_inspector_auth;
            },

            getTitle() {
                return this.field_inspection.is_on_review ? this.shortDateTime(this.field_inspection.review_at) : 'No File Uploaded'
            },
        }
    }
</script>
